import { createBehavior } from '@area17/a17-behaviors';

const inspector = createBehavior(
  'inspector',
  {
    toggle() {
      if (this.isOn) {
        this.isOn = false;
        this.$node.classList.remove('is-on');
        this.currentInspect = null;
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('keyup', this.onKeyUpWhenOn);
      } else {
        this.isOn = true;
        this.$node.classList.add('is-on');
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('keyup', this.onKeyUpWhenOn);
      }
      this.draw();
    },
    onKeyUpWhenOn(evt) {
      if (evt.key === 'Escape') {
        this.toggle();
      }
    },
    onMouseOver(evt) {
      if (this.isOn) {
        this.currentInspect = evt.currentTarget;
        this.draw();
      }
    },
    onMouseOut(evt) {
      if (evt.currentTarget === this.currentInspect && this.isOn) {
        this.currentInspect = null;
        this.draw();
      }
    },
    draw() {
      const $closestComponent = this.currentInspect;
      if ($closestComponent && this.isOn) {
        const name = $closestComponent.getAttribute('data-inspect');
        const rect = $closestComponent.getBoundingClientRect();
        const style = window.getComputedStyle($closestComponent);
        const margin = {
          top: parseInt(style.marginTop, 10) || 0,
          right: parseInt(style.marginRight) || 0,
          bottom: parseInt(style.marginBottom) || 0,
          left: parseInt(style.marginLeft) || 0,
        };
        this.$inspector.classList.add('is-on');
        this.$inspector.innerHTML = `<div class="dev-tools-inspector__label">${name}</div>`;
        this.$inspector.style.width =
          rect.width + margin.left + margin.right + 'px';
        this.$inspector.style.height =
          rect.height + margin.top + margin.bottom + 'px';
        this.$inspector.style.left = rect.left - margin.left + 'px';
        this.$inspector.style.top = rect.top - margin.top + 'px';
      } else {
        this.$inspector.style.width = 0 + 'px';
        this.$inspector.style.height = 0 + 'px';
        this.$inspector.style.left = 0 + 'px';
        this.$inspector.style.top = 0 + 'px';
        this.$inspector.innerHTML = '';
        this.$inspector.classList.remove('is-on');
      }
    },
    onWindowScroll() {
      this.draw();
    },
  },
  {
    init() {
      this.isOn = false;
      this.currentInspect = null;
      this.$inspector = document.querySelector('.dev-tools-inspector');
      this.$inspects = document.querySelectorAll('[data-inspect]');

      this.$node.addEventListener('click', () => {
        this.toggle();
      });

      window.addEventListener('scroll', this.onWindowScroll);

      const lookForInspects = () => {
        if (this.$inspects) {
          for (const $el of this.$inspects) {
            $el.removeEventListener('mouseover', this.onMouseOver);
            $el.removeEventListener('mouseout', this.onMouseOut);
          }
        }
        this.$inspects = document.querySelectorAll('[data-inspect]');
        for (const $el of this.$inspects) {
          $el.addEventListener('mouseover', this.onMouseOver);
          $el.addEventListener('mouseout', this.onMouseOut);
        }
      };

      lookForInspects();

      this.mo = new MutationObserver((mutations) => {
        lookForInspects();
      });

      this.mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      });
    },
    destroy() {
      window.removeEventListener('scroll', this.onWindowScroll);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('keyup', this.onKeyUpWhenOn);
      this.mo.disconnect();
    },
  }
);

export default inspector;
